import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from "axios";
import { APIURL } from "../../../Global";
import { ToggleButton, Button } from 'react-bootstrap';
import { ToggleButtonGroup } from 'react-bootstrap';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import moment from "moment";
import isAfter from 'date-fns/isAfter';
import "rsuite/dist/rsuite.min.css";
import { DatePicker, DateRangePicker } from "rsuite";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
import { MdDownloadForOffline } from "react-icons/md";
import { GrClose } from "react-icons/gr";
import Nav from 'react-bootstrap/Nav';
import jsPDF from "jspdf";
import "jspdf-autotable";

function PhysiotherapyReports() {
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [registerData, setRegisterData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedValue, setSelectedValue] = useState('');
  const [currentDay, setCurrentDay] = useState(moment().format('YYYY-MM-DD'));
  const [currentMonth, setCurrentMonth] = useState(moment().format('MMMM'));
  const [monthsYear, setMonthsYear] = useState(moment().format('YYYY'));
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDownloadDropdownOpen, setIsDownloadDropdownOpen] = useState(false);
  const [selectedYears, setSelectedYears] = useState([]);
  const [selectedDownloads, setSelectedDownloads] = useState([]);
  const currentYear = new Date().getFullYear();
  const [dateRange, setDateRange] = useState(null);
  const [load, setLoad] = useState('');
  const hasMounted = useRef(false);
  const isInitialLoad = useRef(true);
  const [filters, setFilters] = useState({
    pa_name: '',
    pa_age: '',
    pa_address: '',
    role: '',
    pat_type: '',
    date: '',
  });
  const prevFiltersRef = useRef(filters);
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      hasMounted.current = true;
      apiCallFilter(1, perPage, false);
    }
  }, []);

  useEffect(() => {
    const hasAnyFilter = Object.values(filters).some((value) => value !== '');
    const hadAnyFilter = Object.values(prevFiltersRef.current).some((value) => value !== '');

    if (hasMounted.current && !isInitialLoad.current && (hasAnyFilter || hadAnyFilter)) {
      setPage(1);
      setRegisterData([]);
      apiCallFilter(1, perPage, false);
    }

    prevFiltersRef.current = filters;
  }, [filters, perPage]);

  const handleRefresh1 = () => {
    if (hasMounted.current) {
      setFilters({
        pa_name: '',
        pa_age: '',
        pa_address: '',
        role: '',
        pat_type: '',
        date: '',
      });
      setRegisterData([]);
      apiCallFilter(1, perPage);
      setFromDate("");
      setToDate("");
      setSelectedValue("");
    }
  }

  useEffect(() => {
    if (hasMounted.current && fromDate) {
      setPage(1)
      apiCallFilter(1, perPage);
    }
  }, [fromDate, toDate]);

  const handleRefresh = (e) => {
    e.preventDefault();
    setCurrentDay(moment().toDate());
    setCurrentMonth(moment().format('MMMM'));
    setMonthsYear(moment().format('YYYY'));
    setRegisterData([]);
    setPage(1);
    setFromDate("");
    setToDate("");
    handleRefresh1()
    setDateRange(null);
    setFilters({
      pa_name: '',
      pa_age: '',
      pa_address: '',
      role: '',
      pat_type: '',
      date: '',
    });
  };

  const downloadOptions = ["PDF", "CSV"];

  const toggleDownloadDropdown = () => {
    setIsDownloadDropdownOpen(!isDownloadDropdownOpen);
  };

  const handleDownloadChange = (download) => {
    setSelectedDownloads((prevDownloads) => {
      if (prevDownloads.includes(download)) {
        return prevDownloads.filter(item => item !== download);
      } else {
        return [...prevDownloads, download];
      }
    });
  };

  const capitalize = (str) => {
    return str && str !== "" && str.replace(/\b\w/g, c => c.toUpperCase());
  };

  const handleDownloads = () => {
    selectedDownloads.forEach((selectedOption) => {
      if (selectedOption === 'PDF') {
        const unit = "pt";
        const size = "A4";
        const orientation = "portrait";
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const title = "Physiotherapy Report";
        const headers = [["Name", "Age", "Address", "Patient Status", "Department", "Date", "Duration of Stay"]];
        const data = registerData.map((elt) => {
          return [
            capitalize(elt.patient_name),
            elt.age,
            capitalize(elt.address),
            capitalize(elt.role),
            capitalize(elt.pat_type),
            elt.date ? elt.date : '',
            elt.duration_of_stay,
          ];
        });
        let content = {
          startY: 50,
          head: headers,
          body: data
        };
        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("Physiotherapy_Report.pdf");
      } else if (selectedOption === 'CSV') {
        const filteredData = registerData.map(elt => ({
          patient_name: capitalize(elt.patient_name),
          age: elt.age,
          address: capitalize(elt.address),
          role: capitalize(elt.role),
          pat_type: capitalize(elt.pat_type),
          date: elt.date ? elt.date : '',
          duration_of_stay: elt.duration_of_stay
        }));
        const csvContent =
          CsvRegisterheaders.map((h) => h.label).join(',') +
          '\n' +
          filteredData.map((row) => Object.values(row).join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Physiotherapy_Report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
    setSelectedDownloads([]);
    setIsDownloadDropdownOpen(false);
  };

  const handleChangeValue = (val) => {
    setRegisterData([]);
    var startOfWeek = moment().startOf('week').toDate();
    var endOfWeek = moment().endOf('week').toDate();
    var FormatedFirstday = moment((startOfWeek)).format('YYYY-MM-DD');
    var Formatedlastday = moment((endOfWeek)).format('YYYY-MM-DD');
    setFromDate(FormatedFirstday);
    setToDate(Formatedlastday);
    setSelectedValue('week');
  };

  const handleDayChange = (increment) => {
    setRegisterData([]);
    const newDate = moment(currentDay).add(increment, 'days');
    if (newDate.isAfter(moment(), 'day')) {
      setCurrentDay(moment().format('YYYY-MM-DD'));
      return;
    }
    setFromDate(newDate.format('YYYY-MM-DD'));
    setToDate(newDate.format('YYYY-MM-DD'));
    setCurrentDay(newDate.toDate());
    setSelectedValue('day');
  };

  const handleMonthChange = (increment) => {
    setRegisterData([]);
    const currentMoment = moment(`${monthsYear}-${currentMonth}`, 'YYYY-MMMM');
    const newMoment = currentMoment.add(increment, 'months');
    const minMonth = moment().subtract(1, 'year').endOf('month') - 1;
    if (newMoment.isSameOrBefore(minMonth, 'month')) {
      setCurrentMonth(minMonth.format('MMMM'));
      setMonthsYear(minMonth.format('YYYY'));
      return;
    }
    if (newMoment.isAfter(moment(), 'month')) {
      setCurrentMonth(moment().format('MMMM'));
      setMonthsYear(moment().format('YYYY'));
      return;
    }
    const startOfMonth = newMoment.startOf('month').format('YYYY-MM-DD');
    const endOfMonth = newMoment.endOf('month').format('YYYY-MM-DD');
    setFromDate(startOfMonth);
    setToDate(endOfMonth);
    setCurrentMonth(newMoment.format('MMMM'));
    setMonthsYear(newMoment.format('YYYY'));
    setSelectedValue('month');
  };

  const generateYearOptions = () => {
    const years = [];
    for (let year = 2023; year <= currentYear; year++) {
      years.push(String(year));
    }
    return years;
  };

  const filterOptions = [...generateYearOptions()];

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleFilterChange = (filter) => {
    setSelectedYears((prevYears) => {
      if (prevYears.includes(filter)) {
        return [];
      } else {
        return [filter];
      }
    });
  };

  const handleApplyFilters = () => {
    setRegisterData([]);
    if (selectedYears.length > 0) {
      const sortedYears = selectedYears.sort((a, b) => Number(a) - Number(b));
      const startDate = sortedYears[0] + '-01-01';
      const endDate = sortedYears[selectedYears.length - 1] + '-12-31';
      setFromDate(startDate);
      setToDate(endDate);
    }
    setSelectedYears([]);
    setIsDropdownOpen(false);
    setSelectedValue();
  };

  const apiCallFilter = (page, per_page) => {
    const tokenString = sessionStorage.getItem('usertoken');
    if (!tokenString) {
      setLoad('User token is missing');
      return;
    }
    const str = tokenString.replace(/["']+/g, '');

    const searchParams = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].trim() !== '') {
        searchParams[key] = filters[key];
      }
    });

    axios.get(`${APIURL}/api/v1/service-provider/physiotherapy-reports/`, {
      params: {
        start_date: fromDate,
        end_date: toDate,
        page: page,
        per_page: per_page,
        ...searchParams
      },
      headers: {
        "Authorization": 'Token ' + str
      }
    })
      .then(res => {
        if (res.data.status === "success") {
          setHasNext(res.data.has_next);
          setTotalRows(res.data.total_records)
          setLoad('');
          let datalist = res.data.patients;

          setRegisterData(datalist);

        } else {
          setLoad('Error in Fetching Data');
        }
      })
      .catch(err => {
        setLoad('Error in Fetching Data');
      });
  };

  const handleEvent = (value, picker) => {
    setDateRange(value);
    setRegisterData([]);
    if (value && value.length === 2) {
      const [start, end] = value;
      const fromDate = moment(start).format('YYYY-MM-DD');
      const toDate = moment(end).format('YYYY-MM-DD');
      setFromDate(fromDate);
      setToDate(toDate);
      setSelectedValue('');
    } else {
      setFromDate('');
      setToDate('');
      setSelectedValue('');
      handleRefresh1()
    }
  };

  // Generic filter change handler
  const handleFilterChange1 = (filterKey, value) => {
    setFilters(prev => ({
      ...prev,
      [filterKey]: value
    }));
  };

  // Table columns and filters
  const renderTable = (cellInfo) => {
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "15px" }}>
        {registerData[cellInfo.index][cellInfo.column.id]}
      </div>
    );
  };

  const renderTableAddress = (cellInfo) => {
    if (registerData && registerData[cellInfo.index] && registerData[cellInfo.index][cellInfo.column.id]) {
      const dataLines = registerData[cellInfo.index][cellInfo.column.id];
      const words = dataLines.split(' ');
      const lines = [];
      let currentLine = '';
      for (let i = 0; i < words.length; i++) {
        currentLine += words[i] + ' ';
        if ((i + 1) % 2 === 0 || i === words.length - 1) {
          lines.push(currentLine.trim());
          currentLine = '';
        }
      }
      return (
        <div style={{ color: "black", textTransform: "capitalize", fontSize: "13px" }}>
          {lines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      );
    }
    return <div></div>;
  };

  const renderTableDate = (cellInfo) => {
    const date = registerData[cellInfo.index][cellInfo.column.id];
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "15px" }}>
        {date}
      </div>
    );
  };

  // Generic filter component
  const createFilterComponent = (filterKey) => ({ filter, onChange }) => (
    <input
      value={filters[filterKey]}
      onChange={(e) => {
        const filterValue = e.target.value;
        onChange(filterValue);
        handleFilterChange1(filterKey, filterValue);
      }}
      style={{ color: 'black' }}
      placeholder={`Search...`}
    />
  );

  // Table columns with filters
  const columns = [
    {
      Header: "Patient Name",
      accessor: "patient_name",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('pa_name'),
      width: 180
    },
    {
      Header: "Age",
      accessor: "age",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all", textAlign: "center" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('pa_age'),
      width: 100
    },
    {
      Header: "Address",
      accessor: "address",
      Cell: renderTableAddress,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('pa_address'),
      width: 200
    },
    {
      Header: "Patient Status",
      accessor: "role",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row) => {
        const value = row[filter.id];
        if (!filter.value) return true;
        return String(value).toLowerCase() === filter.value.toLowerCase();
      },
      Filter: ({ filter, onChange }) => {
        // Sync with both React Table's filter and your external state
        const currentValue = filter?.value || filters.role || '';

        return (
          <select
            value={currentValue}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange(newValue); // Update React Table's filter
              handleFilterChange1('role', newValue); // Update your external state
            }}
            style={{
              width: '100%',
              padding: '5px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: 'white',
              color: 'black',
            }}
          >
            <option value="">All</option>
            <option value="inpatient">Inpatient</option>
            <option value="outpatient">Outpatient</option>
          </select>
        );
      },
      width: 150
    },
    {
      Header: "Department",
      accessor: "pat_type",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row) => {
        const value = row[filter.id];
        if (!filter.value) return true;
        return String(value).toLowerCase() === filter.value.toLowerCase();
      },
      Filter: ({ filter, onChange }) => {
        const currentValue = filter?.value || filters.pat_type || '';

        return (
          <select
            value={currentValue}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange(newValue);
              handleFilterChange1('pat_type', newValue);
            }}
            style={{
              width: '100%',
              padding: '5px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: 'white',
              color: 'black',
            }}
          >
            <option value="">All</option>
            <option value="shelter">Shelter</option>
            <option value="physiotherapy">Physiotherapy</option>
          </select>
        );
      },
      width: 150
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: renderTableDate,
      style: { whiteSpace: "unset", wordBreak: "break-all", textAlign: 'center' },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: ({ filter, onChange }) => {
        const currentValue = filter?.value || filters.date || '';
        return (
          <DatePicker
            value={currentValue ? new Date(currentValue) : null}
            onChange={(newDate) => {
              const formattedDate = newDate ? new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0] : '';
              onChange(formattedDate);
              handleFilterChange1('date', formattedDate);
            }}
            disabledDate={(date) => date > new Date()}
            format="dd-MM-yyyy"
            cleanable={true}
            oneTap={true}
            maxDate={new Date()}
            placeholder="dd-mm-yyyy"
          />
        );
      },
      width: 120
    },
    {
      Header: "Duration of Stay (days)",
      accessor: "duration_of_stay",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all", textAlign: 'center' },
      sortable: true,
      filterable: false,
    }
  ];

  const CsvRegisterheaders = [
    { label: "Patient Name", key: "patient_name" },
    { label: "Age", key: "age" },
    { label: "Address", key: "address" },
    { label: "Patient Status", key: "role" },
    { label: "Department", key: "pat_type" },
    { label: "Date", key: "date" },
    { label: "Duration of Stay", key: "duration_of_stay" }
  ];

  const handlePageChange = pageIndex => {
    const newPage = pageIndex + 1
    setPage(newPage)
    apiCallFilter(newPage, perPage);

  }
  const getPageSizeOptions = () => {
    const baseOptions = [10, 20, 25, 50, 100];
    const availableOptions = baseOptions.filter(option => option <= totalRows);

    // Always show at least the first option (10) even if totalRows is less
    if (availableOptions.length === 0) {
      return [10];
    }

    return availableOptions;
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1)
    // setRegisterData([]);
    apiCallFilter(1, newPerPage);
  };
  const RowsPerPageSelector = () => {
    const pageSizeOptions = getPageSizeOptions();
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        fontSize: '14px'
      }}>
        <span style={{ marginRight: '10px' }}>Rows per page:</span>
        <select
          value={perPage}
          onChange={(e) => handlePerRowsChange(Number(e.target.value))}
          style={{
            padding: '5px 10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: 'white',
            color: 'black',
            fontSize: '14px'
          }}
        >
          {pageSizeOptions.map(size => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>
    );
  };
  const CustomPagination = ({
    page,
    pageSize,
    pages,
    canPrevious,
    canNext,
    onPageChange
  }) => {
    return (
      <div style={{ display: "flex" }}>
        <button style={{ width: "30%", margin: "3px", borderRadius: "5px", padding: "10px" }} onClick={() => onPageChange(page - 1)} disabled={!canPrevious}>
          Previous
        </button>
        <div style={{
          width: "40%",
          textAlign: "center",
          padding: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px"
        }}>
          <span>Page {totalRows > 0 ? page + 1 : 0} of {pages || 0} </span>
          <RowsPerPageSelector />

        </div>
        <button style={{ width: "30%", margin: "3px", borderRadius: "5px", padding: "10px" }} onClick={() => onPageChange(page + 1)} disabled={!canNext}>
          Next
        </button>
      </div>
    );
  };

  return (
    <div className="patient-report">
      <Nav className="row" style={{ marginTop: "1%", alignContent: 'center', boxSizing: 'border-box' }}>
        <span className="col-6" style={{ width: '35.7%' }}>
          <button className="buttonfilter" style={{ marginTop: "1%", borderRadius: "25px", width: "90px", background: "#1269B9", fontSize: "11px" }} onClick={handleRefresh}>
            <span>Refresh &nbsp;<i className="fa fa-refresh" aria-hidden="true" style={{ color: "white" }}></i> </span>
          </button>
        </span>
        <span className="col-6 togglegroup" style={{ display: 'flex', marginBottom: "1%", textAlign: "right", float: 'right' }}>
          <ToggleButtonGroup className="datepicker-reports" style={{ marginTop: "1%", fontSize: "small" }} type="radio" name="options">
            <DateRangePicker
              appearance="default"
              placeholder={"Select Date Range"}
              value={dateRange}
              onChange={handleEvent}
              disabledDate={(date) => isAfter(date, new Date())}
            >
              <ToggleButton id="tbg-radio-4" value={'custom'} className="btn btn-light toggle-btns custombtn1" style={{ border: 'none', fontSize: '11px' }}></ToggleButton>
            </DateRangePicker>&nbsp;&nbsp;&nbsp;
            <div style={{ display: 'flex', alignItems: 'center', height: '30px', fontSize: '11px', border: `1px solid ${selectedValue === 'day' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}>
              <button className='arrowButton' onClick={() => handleDayChange(-1)}>
                {<AiFillCaretLeft />}
              </button>
              <span style={{ margin: '0 8px', width: '50px', textAlign: 'center', fontSize: '11px' }}>
                {moment(currentDay).isSame(moment(), 'day') ? 'Today' : moment(currentDay).format('YYYY/MM/DD')}
              </span>
              <button className='arrowButton' onClick={() => handleDayChange(1)}>
                {<AiFillCaretRight />}
              </button>
            </div>&nbsp;&nbsp;&nbsp;
            <div style={{ display: 'flex', alignItems: 'center', height: '30px', fontSize: '11px', fontWeight: '400px', border: `1px solid ${selectedValue === 'month' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}>
              <button className='arrowButton' onClick={() => handleMonthChange(-1)}>
                {<AiFillCaretLeft />}
              </button>
              <span style={{ margin: '0 4px', width: '50px', textAlign: 'center' }}>{currentMonth}</span>
              <button className='arrowButton' onClick={() => handleMonthChange(1)}>
                {<AiFillCaretRight />}
              </button>
            </div>&nbsp;&nbsp;&nbsp;
            <button
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px', width: '50px', fontSize: '11px', backgroundColor: 'white', fontWeight: '400px', border: `1px solid ${selectedValue === 'week' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}
              onClick={() => handleChangeValue('week')}
            >
              <span>Week</span>
            </button>&nbsp;&nbsp;&nbsp;
            <div style={{ position: 'relative' }}>
              <button
                className="buttonfilter"
                style={{ borderRadius: "20px", height: '32px', width: '60px', fontSize: '11px', background: isDropdownOpen ? "rgb(13, 197, 197)" : " #1269B9" }}
                onClick={toggleDropdown}
              ><span>
                  More
                </span>
              </button>
              {isDropdownOpen && (
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    padding: '10px',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                    zIndex: 99,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100px',
                    alignItems: 'center',
                  }}
                >
                  {filterOptions.map((filter) => (
                    <label key={filter} style={{ marginBottom: '5px' }}>
                      <input
                        type="checkbox"
                        checked={selectedYears.includes(filter)}
                        onChange={() => handleFilterChange(filter)}
                        disabled={selectedYears.length > 0 && !selectedYears.includes(filter)}
                      />&nbsp;
                      {filter}
                    </label>
                  ))}
                  <button disabled={selectedYears.length === 0} style={{ marginTop: '10px' }} onClick={handleApplyFilters}>
                    Apply
                  </button>
                </div>
              )}
            </div>&nbsp;
            <button
              className="buttonfilter"
              style={{ height: '32px', width: '100px', fontSize: '11px' }}
              onClick={toggleDownloadDropdown}
            ><span>
                Download <MdDownloadForOffline />
              </span>
            </button>
          </ToggleButtonGroup>
        </span>
      </Nav>
      {isDownloadDropdownOpen && (
        <div style={{ position: 'relative', zIndex: 1000 }}>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1000,
            }}
            onClick={() => { }}
          ></div>
          <div className='download-dropdown'
            style={{
              position: 'absolute',
              margin: 'auto',
              width: '30rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              padding: '10px',
              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
              zIndex: 1001,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginLeft: '15rem',
              marginTop: '5%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                borderBottom: '1px solid lightgrey',
                marginBottom: '10px',
                paddingBottom: '10px'
              }}
            >
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  marginLeft: 'auto',
                }}
                onClick={toggleDownloadDropdown}
              >
                <GrClose />
              </button>
            </div>
            <h4 style={{ marginBottom: "2rem" }}>Select the formats to download</h4>
            {downloadOptions.map((download) => (
              <label key={download} style={{ marginBottom: '5px' }}>
                <input
                  type="checkbox"
                  checked={selectedDownloads.includes(download)}
                  onChange={() => handleDownloadChange(download)}
                />&nbsp;
                {download}
              </label>
            ))}
            <button
              variant="primary"
              className='buttonfilter'
              style={{ width: '100px', height: '32px', fontSize: '11px', marginTop: "10px" }}
              onClick={handleDownloads}
            >
              Download
            </button>
          </div>
        </div>
      )}
      <div className="service-table-holder" style={{}}>
        {load === '' ? (
          <ReactTable
            columns={columns}
            data={registerData}
            defaultPageSize={perPage}
            className="chol-table"
            resizable
            minRows={0}
            pageSizeOptions={getPageSizeOptions()}
            // pagination
            showPagination={true}
            manual
            // paginationServer
            onPageChange={handlePageChange}
            pages={Math.ceil(totalRows / perPage)}
            page={page - 1}
            onPageSizeChange={handlePerRowsChange}
            PaginationComponent={CustomPagination}
          />
        ) : load === 'Error in Fetching Data' ? <h6 style={{ color: "red" }}>{load}</h6> : <h6 style={{ color: "grey" }}>{load}</h6>}
      </div>
    </div>
  );
}

export default PhysiotherapyReports;